import {
  NvForm,
  NvModal,
  NvSelectDropdown,
} from '@simwood/nv-react-components';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import CallerIdPicker from '../../../shared/components/CallerIdPicker';
import { setVisibleExtensionMenu } from '../../../shared/reducers/client';
import { editPhoneExtension } from '../../../shared/reducers/contacts';
import { ApiPhoneExtensionWithSip } from '../../../shared/types/PhoneExtension';
import { switchExtension } from '../../reducers/extensionThunks';
import { availableExtensionsSelector } from '../../selectors/contacts';
import { StoreDispatch } from '../../store';

interface Props {
  extension: ApiPhoneExtensionWithSip;
}

const callRecordingOptions = [
  {
    label: 'Always',
    value: 'ALWAYS',
  },
  {
    label: 'On Demand',
    value: 'ON_DEMAND',
  },
  {
    label: 'Off',
    value: 'OFF',
  },
];

const ExtensionSettingsModal: React.FC<Props> = ({ extension }) => {
  const dispatch = useDispatch<StoreDispatch>();
  const availableExtensions = useSelector(availableExtensionsSelector);

  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm<ApiPhoneExtensionWithSip>({
    mode: 'onBlur',
    defaultValues: {
      ...extension,
      // have to do this because otherwise isDirty is always true after initial render
      defaultCallerId: extension.defaultCallerId || null,
    },
  });

  const availableExtensionsOptions = availableExtensions.map((x) => {
    return {
      value: x.id,
      label: `${x.shortNumber} - ${x.name}`,
    };
  });

  const onCancelClicked = () => {
    dispatch(setVisibleExtensionMenu(undefined));
  };

  const submit = (modifiedEntity: ApiPhoneExtensionWithSip) => {
    if (isDirty) {
      dispatch(editPhoneExtension(modifiedEntity));
    }
    dispatch(setVisibleExtensionMenu(undefined));
  };

  return (
    <NvModal.Form
      size='standard'
      title='Extension Settings'
      open={true}
      disabled={!isDirty}
      closeOnSubmit
      onSubmit={handleSubmit(submit)}
      setOpen={onCancelClicked}
      submitText='Save'
    >
      <NvSelectDropdown
        name='extension'
        labelText='Extension'
        items={availableExtensionsOptions}
        value={extension.id}
        onChange={(selected) => {
          dispatch(switchExtension(selected));
        }}
      />
      <CallerIdPicker
        labelText='Default Caller Id'
        includeAnonymous
        control={control}
      />
      <NvForm.Select
        name='callRecording'
        control={control}
        labelText='Call Recording'
        items={callRecordingOptions}
      />
      <NvForm.Checkbox
        name='callWaiting'
        control={control}
        labelText='Call Waiting'
      />
    </NvModal.Form>
  );
};

export default ExtensionSettingsModal;
